import twoLineBasicFn from './twoLineBasic';
import twoLineCenterFn from './twoLineCenter';
import staticCenterFn from './staticCenter';

const formatLabel = (type, group, seriesModel) => {
  switch (type) {
    case 'twoLineBasic':
      twoLineBasicFn(group, seriesModel)
      break;
    case 'twoLineCenter':
      twoLineCenterFn(group, seriesModel)
      break;
    case 'staticCenter':
      staticCenterFn(group, seriesModel)
      break;
    default:
      return [];
  }
}

export default formatLabel;
